/* ===========================================================================
   tsv-localize-links.js — keep shoppers inside their language
   The Scent Vault · thescentvault.ie

   A link written as  https://thescentvault.ie/pages/the-members-vault
   or as              /pages/the-members-vault
   always lands on the ENGLISH page, even when the shopper is on /fr/.
   Shopify does not add the locale prefix to either form — only Liquid that
   emits {{ routes.root_url }} gets it right, and 53 link settings plus ~20
   Liquid files in this theme do not.

   This rewrites same-shop links to carry the current locale prefix. On the
   primary locale it exits immediately and does nothing at all.

   Opt out of a single link with  data-no-locale  (or put it on a container).
   =========================================================================== */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (root === '/' || !root) return;                 // primary locale — nothing to do
  var PREFIX = root.replace(/\/+$/, '');             // "/fr"
  if (!PREFIX) return;

  // Every locale this store publishes. A path already starting with one of
  // these is deliberate (the language switcher) and must not be touched.
  var LOCALES = ['de', 'fr', 'es', 'it', 'sv', 'en'];

  // Shopify-owned paths that must never be prefixed.
  var RESERVED = /^\/(admin|cdn|cdn-cgi|apps|services|wpm|.well-known|_t|localization|checkouts?|cart\/change|cart\/update|cart\/add|cart\/clear|payments|wallets|account\/logout)(\/|$|\?)/i;

  var HOSTS = null;
  function sameShop(host) {
    if (!host) return true;                          // relative — same shop by definition
    if (!HOSTS) {
      HOSTS = [location.hostname.toLowerCase()];
      var d = (window.Shopify && window.Shopify.shop) ? String(window.Shopify.shop).toLowerCase() : '';
      if (d) HOSTS.push(d);
      HOSTS.push('thescentvault.ie', 'www.thescentvault.ie');
    }
    host = host.toLowerCase().replace(/:\d+$/, '');
    return HOSTS.indexOf(host) >= 0;
  }

  function localize(raw) {
    if (!raw) return null;
    var s = String(raw).trim();
    if (!s) return null;

    // Schemes and fragments we never touch.
    if (/^(mailto:|tel:|sms:|javascript:|data:|blob:|#)/i.test(s)) return null;

    var path = null;
    var m = s.match(/^(https?:)?\/\/([^\/?#]+)(\/[^]*)?$/i);
    if (m) {
      if (!sameShop(m[2])) return null;              // external site
      path = m[3] || '/';
      // keep the original absolute form's origin so nothing else changes
      var origin = (m[1] || location.protocol) + '//' + m[2];
      var out = rewrite(path);
      return out === null ? null : origin + out;
    }
    if (s.charAt(0) !== '/') return null;            // "?x", "foo.html" — leave alone
    return rewrite(s);
  }

  function rewrite(path) {
    if (RESERVED.test(path)) return null;
    // already carries this locale
    if (path === PREFIX || path.indexOf(PREFIX + '/') === 0 ||
        path.indexOf(PREFIX + '?') === 0 || path.indexOf(PREFIX + '#') === 0) return null;
    // already carries SOME locale (language switcher, hreflang links)
    var seg = path.split(/[\/?#]/)[1] || '';
    if (LOCALES.indexOf(seg.toLowerCase()) >= 0) return null;
    return PREFIX + path;
  }

  function fixOne(a) {
    if (a.__tsvLoc) return;
    a.__tsvLoc = 1;
    if (a.hasAttribute('data-no-locale') || a.closest('[data-no-locale]')) return;
    if (a.closest('form[action*="localization"]')) return;
    var raw = a.getAttribute('href');
    var next = localize(raw);
    if (next && next !== raw) a.setAttribute('href', next);
  }

  function sweep(scope) {
    var links = (scope || document).querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) fixOne(links[i]);
  }

  function start() {
    sweep(document);
    if (window.MutationObserver) {
      var pending = false;
      new MutationObserver(function (recs) {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          for (var i = 0; i < recs.length; i++) {
            var added = recs[i].addedNodes;
            for (var j = 0; j < added.length; j++) {
              var n = added[j];
              if (n.nodeType !== 1) continue;
              if (n.tagName === 'A') fixOne(n);
              else if (n.querySelectorAll) sweep(n);
            }
          }
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  // Belt and braces: catch a click on anything that slipped through — a link
  // injected and clicked before the observer fired, or an href set by script.
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href]');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (a.target && a.target !== '_self') return;
    if (a.hasAttribute('data-no-locale') || a.closest('[data-no-locale]')) return;
    var next = localize(a.getAttribute('href'));
    if (next) a.setAttribute('href', next);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  window.TSVLocalizeLinks = { sweep: sweep, localize: localize, prefix: PREFIX };
})();
